import { useState } from 'react'

const useFields = () => {
  const [isStepValid, setIsStepValid] = useState(true)

  return {
    isStepValid,
    setIsStepValid,
  }
}

export default useFields
